import {takeLatest} from 'redux-saga/effects';
import * as ACTION from './constants';
import * as saga from './saga';

export default function*() {
    yield takeLatest(ACTION.FETCH_SERVICES.REQUEST, saga.getServices);
}
